function MessagesIcon() {
  return (
    <svg
      className="nhsapp-icon"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      style={{
        fill: '#ffffff',
        width: '1.5rem',
        height: '1.5rem',
      }}
    >
      <path d="M21.44 12.66c-.75.34-1.64.67-1.8.73l-7.46 3.05c-.06.02-.12.03-.18.04-.06 0-.12-.01-.18-.04l-7.46-3.05c-.16-.06-1.05-.4-1.8-.73a.397.397 0 0 0-.56.37v8.16c0 .46.37.83.82.83h18.35c.45 0 .82-.37.82-.83v-8.16c0-.29-.3-.48-.56-.37Z" />
      <path d="M19.53 3.72H4.47c-.41 0-.75.34-.75.75v7.11L12 14.9l8.28-3.32V4.47c0-.41-.34-.75-.75-.75Z" />
    </svg>
  );
}

export default MessagesIcon;
